var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptabilidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_15073",
    "data-name": "Grupo 15073",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.527,
    height: 44.527,
    viewBox: "0 0 44.527 44.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 22.263,
    cy: 22.263,
    r: 22.263,
    fill: "#009bde"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "analytics_FILL0_wght400_GRAD0_opsz48",
    d: "M125.993-828.93a.888.888,0,0,0-.659.267.9.9,0,0,0-.263.661v4.484a.9.9,0,0,0,.268.661.905.905,0,0,0,.665.267.887.887,0,0,0,.659-.267.9.9,0,0,0,.263-.661V-828a.9.9,0,0,0-.268-.661A.906.906,0,0,0,125.993-828.93Zm10.266-6.648a.888.888,0,0,0-.659.267.9.9,0,0,0-.263.661v11.132a.9.9,0,0,0,.268.661.905.905,0,0,0,.665.267.887.887,0,0,0,.659-.267.9.9,0,0,0,.263-.661v-11.132a.9.9,0,0,0-.268-.661A.906.906,0,0,0,136.259-835.578Zm-5.133,9.338a.888.888,0,0,0-.659.267.9.9,0,0,0-.263.661v1.793a.9.9,0,0,0,.268.661.905.905,0,0,0,.665.267.887.887,0,0,0,.659-.267.9.9,0,0,0,.263-.661v-1.793a.9.9,0,0,0-.268-.661A.906.906,0,0,0,131.126-826.24Zm-9.271,8.5a1.78,1.78,0,0,1-1.3-.557,1.78,1.78,0,0,1-.557-1.3v-18.553a1.78,1.78,0,0,1,.557-1.3,1.78,1.78,0,0,1,1.3-.557h18.553a1.78,1.78,0,0,1,1.3.557,1.78,1.78,0,0,1,.557,1.3v18.553a1.78,1.78,0,0,1-.557,1.3,1.78,1.78,0,0,1-1.3.557Zm0-1.855h18.553v-18.553H121.855Zm0-18.553v0Zm9.282,9.215a.885.885,0,0,0,.659-.268.912.912,0,0,0,.263-.665.885.885,0,0,0-.268-.659.913.913,0,0,0-.665-.263.885.885,0,0,0-.659.268.912.912,0,0,0-.263.665.885.885,0,0,0,.268.659A.913.913,0,0,0,131.137-828.93Z",
    transform: "translate(-108.868 851.131)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptabilidade);
export default __webpack_public_path__ + "static/media/adaptabilidade.a184cfcd929033532803c91061b720bd.svg";
export { ForwardRef as ReactComponent };